import _ from 'underscore';
import React from 'react';
import { ScopeContext } from '../common/scope-context';
import { DefaultParamProvider } from '../common/default-param-provider';
import { IScopeValue, ScopeParameter, ScopeParameters } from '../types';

export interface IUpdaterProps {
  // eslint-disable-next-line react/no-unused-prop-types -- only consumed via static getDerivedStateFromProps
  scope: IScopeValue;
  // eslint-disable-next-line react/no-unused-prop-types -- only consumed via static getDerivedStateFromProps
  defaultScope: ScopeParameters;
}

export interface IUpdaterState {
  scope: IScopeValue;
  defaultScope: ScopeParameters;
}

class Updater extends React.PureComponent<IUpdaterProps, IUpdaterState> {
  static getDerivedStateFromProps({ scope, defaultScope }: IUpdaterProps): IUpdaterState {
    return {
      scope,
      defaultScope,
    };
  }

  state: IUpdaterState = {
    scope: {} as IScopeValue,
    defaultScope: {},
  };

  componentDidMount() {
    this.updateScope();
  }

  componentDidUpdate() {
    this.updateScope();
  }

  updateScope() {
    const { scope, defaultScope } = this.state;

    if (_.find(defaultScope, (_val: ScopeParameter, key: string) => !_.has(scope.values, key))) {
      scope.set(_.defaults(scope.values, defaultScope));
      scope.save();
    }
  }

  render(): null {
    return null;
  }
}

export interface IScopeUpdaterProps {
  defaults?: ScopeParameters;
}

export const ScopeUpdater: React.FC<IScopeUpdaterProps> = ({
  defaults
}) => (
  <ScopeContext.Consumer>

    {({
      scope
    }) => (<Updater scope={scope!} defaultScope={defaults!} />)}
  </ScopeContext.Consumer>
);

ScopeUpdater.defaultProps = {
  defaults: DefaultParamProvider.defaultProps.defaults,
};
